import { Button, CloseIconThin, MenuIcon } from '@cmsgov/design-system';
import classnames from 'classnames';
import { sendHeaderEvent } from "./analytics";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/compat/jsx-runtime";
const menuId = 'hc-c-menu';
/**
 * ActionMenu is displayed at the top-right of the header.
 * There are two variations of this component: One for logged-out
 * users, which displays a "Log in" & "Espanol" link on desktop.
 * And another for logged-in users, which includes the user's first
 * name. The logged-in variation always displays a "Menu" toggle
 * button, and the logged-out variation only displays it on mobile.
 */
const ActionMenu = function (props) {
  function onClick(event) {
    sendHeaderEvent(props.open ? 'menu closed' : 'menu opened');
    props.onMenuToggleClick(event);
  }
  const menuButton = /*#__PURE__*/_jsxs(Button, {
    "aria-controls": menuId,
    "aria-expanded": !!props.open,
    "aria-label": props.open ? props.t('header.closeMenu') : props.t('header.openMenu'),
    className: classnames('hc-c-action-menu-button', 'ds-u-sm-margin-left--2', {
      'ds-u-display--inline-block ds-u-sm-display--none': !props.loggedIn
    }),
    onClick: onClick,
    size: "small",
    children: [props.open ? /*#__PURE__*/_jsx(CloseIconThin, {
      className: "ds-u-margin-right--1"
    }) : /*#__PURE__*/_jsx(MenuIcon, {
      className: "ds-u-margin-right--1"
    }), /*#__PURE__*/_jsx("span", {
      children: props.t('header.menu')
    })]
  });
  let content;
  if (props.loggedIn) {
    content = /*#__PURE__*/_jsxs(_Fragment, {
      children: [props.firstName && /*#__PURE__*/_jsx("span", {
        className: "ds-u-display--none ds-u-sm-display--inline-block",
        children: props.firstName
      }), menuButton]
    });
  } else if (props.links.length) {
    content = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("ul", {
        role: "list",
        className: "hc-c-logged-out-links ds-c-list--bare ds-u-display--none ds-u-sm-display--flex",
        children: props.links.map(link => {
          return /*#__PURE__*/_jsx("li", {
            className: "hc-c-logged-out-links__li",
            children: /*#__PURE__*/_jsx("a", {
              href: link.href,
              "aria-label": link.ariaLabel
              // TODO: .toString() here pacifies TypeScript, but TypeScript has actually found a
              // potential bug here where we allow link.label to be a ReactNode, but a ReactNode
              // can't actually be coerced into a string. We've had to do a lot of extra work in
              // other cases to find the text content of a ReactNode after rendering, like in
              // packages/design-system/src/components/Alert/Alert.tsx#L114
              ,
              onClick: () => sendHeaderEvent(link.label.toString(), link.href),
              className: classnames('hc-c-logged-out-links__link', link.className),
              children: link.label
            })
          }, link.href);
        })
      }), menuButton]
    });
  } else {
    content = null;
  }
  return content;
};
export default ActionMenu;